export const PAID = ["lite", "pro", "team"];
export const isPaid = (ws) => PAID.includes(ws?.plan);
export const hasBot = (ws) => ["pro", "team"].includes(ws?.plan);
export const fmtRM = (n) => (Number.isInteger(n) ? n.toLocaleString("en-MY") : n.toFixed(2));

export const PLAN_COPY = {
  free: {
    name: ["Percuma", "Free"],
    tagline: ["Cuba MinitAI dengan satu rakaman.", "Try MinitAI with one recording."],
    features: [
      ["Rakam (mikrofon + audio sistem/tab)", "Record (mic + system/tab audio)"],
      ["Muat naik audio (seret & lepas)", "Upload audio (drag & drop)"],
      ["Transkripsi langsung semasa merakam (mikrofon)", "Live transcription while recording (mic)"],
      ["Transkrip terperinci + pengenalan penutur", "Detailed transcript + speaker recognition"],
      ["1 transkripsi sahaja (maks. 30 minit, fail ≤50 MB)", "1 transcription only (max 30 min, file ≤50 MB)"],
    ],
    excluded: [["Dokumen AI, eksport & perkongsian", "AI documents, export & sharing"], ["Mesyuarat Online (bot Zoom, Meet & Teams)", "Online Meeting (Zoom, Meet & Teams bot)"]],
  },
  lite: {
    name: ["Lite", "Lite"],
    tagline: ["Untuk pelajar & pengguna ringan.", "For students & light users."],
    features: [
      ["Semua dalam Percuma, tanpa had 1 transkripsi", "Everything in Free, no 1-transcription limit"],
      ["Muat naik fail sehingga 150 MB (Pro & Team: 300 MB)", "File uploads up to 150 MB (Pro & Team: 300 MB)"],
      ["4 dokumen: Minit Rasmi, Nota Kuliah, Laporan, Temubual", "4 documents: Official Minutes, Lecture Notes, Report, Interview"],
      ["Sunting dokumen + eksport PDF, DOCX, TXT, PPTX, CSV", "Edit documents + export PDF, DOCX, TXT, PPTX, CSV"],
      ["Kongsi melalui WhatsApp, Emel & pautan", "Share via WhatsApp, Email & link"],
      ["Terjemahan, glosari, kapsyen skrin penuh", "Translation, glossary, fullscreen captions"],
      ["Rakaman sehingga 2 jam", "Recordings up to 2 hours"],
    ],
    excluded: [["Mesyuarat Online (bot Zoom, Meet & Teams)", "Online Meeting (Zoom, Meet & Teams bot)"]],
  },
  pro: {
    name: ["Pro", "Pro"],
    tagline: ["Untuk pensyarah, setiausaha & profesional.", "For lecturers, secretaries & professionals."],
    features: [
      ["Semua dalam Lite", "Everything in Lite"],
      ["Mesyuarat Online: bot Zoom, Meet & Teams (minit bot dikira 1.5×)", "Online Meeting: Zoom, Meet & Teams bot (bot minutes count 1.5×)"],
      ["Transkripsi langsung audio sistem/tab", "Live system/tab audio transcription"],
      ["Folder untuk menyusun mesyuarat", "Folders to organise meetings"],
      ["Rakaman sehingga 4 jam", "Recordings up to 4 hours"],
    ],
  },
  team: {
    name: ["Team Asas", "Team Basic"],
    tagline: ["Untuk jabatan, unit & pasukan kecil.", "For departments, units & small teams."],
    features: [
      ["Semua dalam Pro", "Everything in Pro"],
      ["Workspace pasukan sehingga 5 ahli", "Team workspace up to 5 members"],
      ["Peranan admin / ahli / pemerhati", "Admin / member / viewer roles"],
      ["Kongsi mesyuarat dalam pasukan + kuota dikongsi", "Share meetings in-team + shared quota"],
      ["Logo organisasi pada Minit Rasmi", "Organisation logo on Official Minutes"],
      ["Papan penggunaan pasukan & sokongan keutamaan", "Team usage dashboard & priority support"],
    ],
  },
};

export const ENTERPRISE = {
  name: ["Organisasi / Kerajaan", "Organisation / Government"],
  price: ["Mulai RM999", "From RM999"],
  tagline: ["Untuk kementerian, agensi, GLC & universiti.", "For ministries, agencies, GLCs & universities."],
  features: [
    ["Semua dalam Team, ahli tanpa had", "Everything in Team, unlimited members"],
    ["Kuota minit & dokumen ikut kontrak", "Minutes & document quota by contract"],
    ["Templat Minit Rasmi ikut format jabatan", "Official Minutes template per department format"],
    ["Invois / PO kerajaan, SSO", "Government invoice / PO, SSO"],
    ["Perjanjian perlindungan data (PDPA)", "Data protection agreement (PDPA)"],
  ],
};
